import React, { Fragment, useEffect } from "react";
import { Field, useForm, useFormState } from "react-final-form";
import { OnChange } from "react-final-form-listeners";

// Web Final Form Components
import { FormGroup, Label, Col } from "reactstrap";
import { InputField, ReactSelect, ToggleField, required } from "modules/4_final_form/web";

// Mobile Final Form Components
import { SmartSelect } from "modules/4_final_form/mobile";
import { connect } from "react-redux";
import ProjectAddButton from "modules/projects/web/add_button";
import { getProjectStatuses } from "modules/project/statuses/actions";
import _ from "lodash";

const mapStateToProps = (state, ownProps) => {
  return {
    projects: state.projects,
    project_statuses: state.project_statuses,
  };
};

export let ProjectAttributes = (props) => {
  const { fieldName, namesUsed } = props;

  useEffect(() => {
    props.getProjectStatuses();
  }, []);

  const project_statuses = _.filter(props.project_statuses, (s) => s.role == 1);

  const form = useForm();
  const formState = useFormState();
  const thisField = _.get(formState?.values, fieldName);

  return (
    <Fragment>
      <FormGroup row>
        <Label md={3}>Label</Label>
        <Col md={8}>
          <Field name={`${fieldName}.label`} component={InputField} />
          <OnChange name={`${fieldName}.label`}>
            {(value, previous) => {
              if (value) {
                let name = _.snakeCase(value);
                // Check first character is a number
                if (name.match(/^\d/)) {
                  name = `_${name}`;
                }
                form.change(`${fieldName}.name`, name);
              }
            }}
          </OnChange>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>Name</Label>
        <Col md={8}>
          <Field
            name={`${fieldName}.name`}
            component={InputField}
            validate={(value, values) => {
              if (!value) {
                return "is required";
              }
              if (namesUsed.includes(value)) {
                return "must be unique";
              }
            }}
            convertToLowerCase
            lettersOnly
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>Placeholder</Label>
        <Col md={8}>
          <Field name={`${fieldName}.placeholder`} component={InputField} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>Required Field</Label>
        <Col md={8}>
          <Field name={`${fieldName}.required`} component={ToggleField} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>On Dashboard</Label>
        <Col md={8}>
          <Field name={`${fieldName}.on_dashboard`} component={ToggleField} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>On Report</Label>
        <Col md={8}>
          <Field name={`${fieldName}.on_report`} component={ToggleField} />
        </Col>
      </FormGroup>
      <hr />
      <FormGroup row>
        <Label md={3}>Ability to add new</Label>
        <Col md={8}>
          <Field name={`${fieldName}.add_new`} component={ToggleField} />
        </Col>
      </FormGroup>
      {thisField?.add_new && (
        <Fragment>
          <FormGroup row>
            <Label md={3}>Default Project Status</Label>
            <Col md={8}>
              <Field
                name={`${fieldName}.default_status_id`}
                component={ReactSelect}
                isClearable
                parse={(value) => value}
                options={_.map(project_statuses, (s) => {
                  return { value: s.id, label: s.name };
                })}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3}>Disable existing projects</Label>
            <Col md={8}>
              <Field name={`${fieldName}.disable_existing`} component={ToggleField} />
            </Col>
          </FormGroup>
        </Fragment>
      )}
    </Fragment>
  );
};

ProjectAttributes = connect(mapStateToProps, { getProjectStatuses })(ProjectAttributes);

const mapStateToPropsForm = (state, ownProps) => {
  return {
    projects: state.projects,
    project_variation_numbers: state.project_variation_numbers,
  };
};

export let ProjectFieldForm = (props) => {
  const {
    label,
    placeholder,
    required: isRequired,
    preview,
    name,
    prefixName,
    disabled,
    projects,
    add_new,
    default_status_id,
    disable_existing,
  } = props;

  const sorted_projects = _.sortBy(projects, (p) => parseInt(p.number));

  const form = useForm();
  return (
    <Fragment>
      <FormGroup row>
        <Label md={2}>
          {label}
          {isRequired && "*"}
          {add_new && (
            <ProjectAddButton
              initialValues={{ status_id: default_status_id }}
              onSuccess={(id) => {
                if (id) {
                  form.change(`${prefixName}.${name}`, id);
                }
              }}
            />
          )}
        </Label>
        <Col md={10}>
          <Field
            name={`${prefixName}.${name}`}
            disabled={preview || disabled}
            component={ReactSelect}
            options={_.map(sorted_projects, (p) => {
              return { value: p.id, label: p.display_name, isDisabled: disable_existing && !p.new_record };
            })}
            placeholder={placeholder || "Select Project"}
            validate={isRequired && !preview ? required : null}
          />
        </Col>
      </FormGroup>
    </Fragment>
  );
};
ProjectFieldForm.defaultProps = {
  prefixName: "data",
};

ProjectFieldForm = connect(mapStateToPropsForm)(ProjectFieldForm);

const mapStateToPropsFormMobile = (state, ownProps) => {
  return {
    projects: state.projects,
  };
};

export let MobileProjectFieldForm = (props) => {
  const { label, placeholder, required: isRequired, preview, name, prefixName, disabled, projects, disable_existing } = props;

  const sorted_projects = _.sortBy(projects, (p) => parseInt(p.number));

  return (
    <Field
      name={`${prefixName}.${name}`}
      label={label}
      disabled={preview || disabled}
      component={SmartSelect}
      options={_.map(sorted_projects, (sp) => {
        return { value: sp.id, label: sp.display_name, isDisabled: disable_existing && !sp.new_record };
      })}
      placeholder={placeholder}
      validate={isRequired && !preview ? required : null}
      valueName="value"
      labelName="label"
    />
  );
};

MobileProjectFieldForm = connect(mapStateToPropsFormMobile)(MobileProjectFieldForm);

MobileProjectFieldForm.defaultProps = {
  prefixName: "data",
};
